export const congregationsPl = {
  congregations: {
    list: {
      title: 'Zbory CHWZ',
      description: 'Lista zborów Chrześcijańskiej Wspólnoty Zielonoświątkowej',
      unpublish: 'Cofnij publikację',
      unpublishConfirm: 'Czy na pewno chcesz cofnąć publikację tego zboru?',
      unpublishSuccess: 'Zbór został cofnięty z publikacji',
      unpublishError: 'Nie udało się cofnąć publikacji zboru',
      create: 'Dodaj zbór',
      createTitle: 'Dodaj nowy zbór',
      createDescription: 'Utwórz nowy zbór. Pełne dane (adres, godziny nabożeństw) uzupełnisz po utworzeniu.',
      createSuccess: 'Zbór został utworzony',
      createDraftHint: 'Zbór jest widoczny jako szkic. Aby opublikować go publicznie, uzupełnij adres i ustaw status adresu na opublikowany.',
      createError: 'Nie udało się utworzyć zboru',
      nameRequired: 'Nazwa jest wymagana',
      deleteConfirm: 'Czy na pewno chcesz usunąć ten zbór?',
      deleteSuccess: 'Zbór został usunięty',
      deleteError: 'Nie udało się usunąć zboru',
      error: 'Nie udało się załadować listy zborów',
      empty: 'Brak zborów do wyświetlenia',
      searchPlaceholder: 'Szukaj zborów...',
      noResults: 'Brak wyników dla podanej frazy',
      branch: 'Placówka',
      branchOf: 'Placówka zboru {name}',
      view: {
        grid: 'Siatka',
        list: 'Lista',
        map: 'Mapa',
        toggleLabel: 'Tryb wyświetlania',
        mapMissingCoordinates: 'Zbory bez współrzędnych nie są pokazane | 1 zbór bez współrzędnych nie jest pokazany | {count} zbory bez współrzędnych nie są pokazane | {count} zborów bez współrzędnych nie jest pokazanych',
      },
    },
    detail: {
      title: 'Zbór',
      notFound: 'Zbór nie został znaleziony lub nie masz do niego dostępu.',
      notFoundTitle: 'Nie znaleziono zboru',
      errorTitle: 'Wystąpił błąd',
      error: 'Nie udało się załadować danych zboru',
      edit: 'Edytuj',
      address: 'Adres',
      congregationContact: 'Kontakt zboru',
      serviceTimes: 'Godziny nabożeństw',
      contacts: 'Kontakt',
      hiddenContacts: 'Ukryte (widoczne tylko dla edytorów)',
      branches: 'Placówki',
      back: 'Wróć do listy zborów',
      map: 'Mapa',
      openInGoogleMaps: 'Otwórz w Google Maps',
    },
    map: {
      unavailable: 'Mapa jest chwilowo niedostępna',
    },
    share: {
      title: 'Udostępnianie przez link',
      globalTitle: 'Udostępnij wszystkie zbory',
      globalDescription: 'Każdy z tym linkiem może przeglądać wszystkie opublikowane zbory, bez logowania. Poziom dostępu poniżej decyduje, ile danych kontaktowych zostanie ujawnionych.',
      readOnlyNote: 'Link zawsze daje wyłącznie dostęp do odczytu na wybranym poziomie — nigdy prawa do edycji ani członkostwa.',
      create: 'Utwórz link',
      createTitle: 'Utwórz link do udostępnienia',
      createError: 'Nie udało się utworzyć linku',
      empty: 'Brak aktywnych linków',
      visibilityLevel: 'Poziom widoczności',
      expiresIn: 'Okres ważności',
      expiresInDays: '{count} dni',
      expiresAt: 'Wygasa: {date}',
      label: 'Etykieta (opcjonalnie)',
      labelPlaceholder: 'np. Dla brata Kowalskiego',
      generatedLink: 'Wygenerowany link',
      copyLink: 'Kopiuj link',
      copySuccess: 'Link skopiowany do schowka',
      revoke: 'Odwołaj',
      revokeConfirm: 'Czy na pewno chcesz odwołać ten link? Przestanie działać natychmiast.',
      revokeSuccess: 'Link został odwołany',
      revokeError: 'Nie udało się odwołać linku',
    },
    sharedView: {
      title: 'Udostępniony zbór',
      allTitle: 'Zbory',
      invalidTitle: 'Link nieprawidłowy',
      invalid: 'Ten link jest nieprawidłowy, wygasł lub został odwołany.',
      poweredBy: 'Udostępniono przez',
    },
    filters: {
      searchPlaceholder: 'Szukaj po nazwie, mieście, adresie, kontakcie...',
      country: 'Kraj',
      anyCountry: 'Wszystkie kraje',
      province: 'Województwo',
      anyProvince: 'Wszystkie województwa',
      hideBranches: 'Ukryj placówki',
      reset: 'Wyczyść filtry',
      more: 'Więcej',
      less: 'Mniej',
      resultCount: 'Brak zborów | 1 zbór | {count} zbory | {count} zborów',
      myLocation: 'Użyj mojej lokalizacji',
      locating: 'Ustalanie lokalizacji...',
      locationError: 'Nie udało się ustalić lokalizacji',
      clearLocation: 'Wyczyść lokalizację',
      maxDistance: 'Promień',
      anyDistance: 'Dowolny',
      distanceKm: '{km} km',
      sortByDistance: 'Sortuj wg odległości',
      missingCoordinates: 'Pominięto zbory bez współrzędnych | Pominięto 1 zbór (brak współrzędnych) | Pominięto {count} zbory (brak współrzędnych) | Pominięto {count} zborów (brak współrzędnych)',
    },
    export: {
      button: 'Eksport',
      json: 'Eksportuj do JSON',
      markdown: 'Eksportuj do Markdown',
      title: 'Zbory CHWZ',
      exportedAt: 'Wyeksportowano',
      count: 'Liczba pozycji',
      branchOf: 'Placówka zboru',
      address: 'Adres',
      serviceTimes: 'Nabożeństwa',
      contact: 'Kontakt',
      previewTitle: 'Podgląd eksportu Markdown',
      previewDescription: 'Skopiuj treść lub pobierz plik .md',
      download: 'Pobierz',
      copyError: 'Nie udało się skopiować do schowka',
    },
    status: {
      unverified: 'Niezweryfikowany',
      draft: 'Szkic',
      published: 'Opublikowany',
      publishedUnverified: 'Opublikowany (niezweryfikowany)',
      needVerification: 'Wymaga weryfikacji',
    },
    edit: {
      title: 'Edytuj zbór',
      subtitle: 'Zarządzaj informacjami o zborze',
      loadError: 'Nie udało się załadować danych zboru',
      nameRequired: 'Nazwa jest wymagana',
      lastUpdatedBy: 'Ostatnia zmiana danych',
      basicInfo: {
        title: 'Podstawowe informacje',
        name: 'Nazwa',
        namePlaceholder: 'Wprowadź nazwę zboru',
        description: 'Opis',
        descriptionPlaceholder: 'Wprowadź opis zboru (opcjonalnie)',
        status: 'Status',
        saveSuccess: 'Podstawowe informacje zostały zapisane',
        saveError: 'Nie udało się zapisać podstawowych informacji',
      },
      address: {
        title: 'Adres',
        street: 'Ulica',
        streetPlaceholder: 'Wprowadź ulicę',
        city: 'Miasto',
        cityPlaceholder: 'Wprowadź miasto',
        cityRequired: 'Miasto jest wymagane',
        postalCode: 'Kod pocztowy',
        postalCodePlaceholder: 'Wprowadź kod pocztowy',
        province: 'Województwo',
        provincePlaceholder: 'Wybierz województwo',
        country: 'Kraj',
        website: 'Strona WWW',
        websitePlaceholder: 'np. https://example.pl',
        email: 'E-mail zboru',
        emailPlaceholder: 'np. kontakt\\@example.pl',
        emailInvalid: 'Nieprawidłowy adres e-mail',
        iban: 'Numer konta',
        ibanPlaceholder: 'np. 61 1090 1014 0000 0712 1981 2874',
        location: 'Lokalizacja na mapie',
        latitude: 'Szerokość geograficzna',
        longitude: 'Długość geograficzna',
        mapClickHint: 'Kliknij na mapie, aby ustawić lokalizację zboru',
        mapDragHint: 'Przeciągnij pinezkę, aby poprawić lokalizację',
        geocodeButton: 'Geokoduj adres',
        geocoding: 'Geokodowanie...',
        geocodeSuccess: 'Współrzędne zostały uzupełnione',
        geocodeNotFound: 'Nie znaleziono współrzędnych dla tego adresu',
        geocodeError: 'Nie udało się geokodować adresu',
        status: 'Status adresu',
        saveSuccess: 'Adres został zapisany',
        saveError: 'Nie udało się zapisać adresu',
      },
      serviceTimes: {
        title: 'Godziny nabożeństw',
        empty: 'Brak godzin nabożeństw. Kliknij "Dodaj" aby dodać nową.',
        saveSuccess: 'Godziny nabożeństw zostały zapisane',
        saveError: 'Nie udało się zapisać godzin nabożeństw',
      },
      serviceTime: {
        day: 'Dzień',
        dayPlaceholder: 'np. Niedziela',
        dayRequired: 'Dzień jest wymagany',
        time: 'Godzina',
        timePlaceholder: 'np. 10:00',
        timeRequired: 'Godzina jest wymagana',
        description: 'Opis',
        descriptionPlaceholder: 'np. Modlitwa nocna',
      },
      weekdays: {
        sunday: 'Niedziela',
        monday: 'Poniedziałek',
        tuesday: 'Wtorek',
        wednesday: 'Środa',
        thursday: 'Czwartek',
        friday: 'Piątek',
        saturday: 'Sobota',
      },
      weekdaysShort: {
        sunday: 'Nie',
        monday: 'Pon',
        tuesday: 'Wto',
        wednesday: 'Śro',
        thursday: 'Czw',
        friday: 'Pią',
        saturday: 'Sob',
      },
      serviceTimeQuickAdd: {
        title: 'Szybkie dodawanie',
        hint: 'Zaznacz dni, wpisz godzinę i dodaj kilka wpisów naraz.',
        time: 'Godzina',
        add: 'Dodaj zaznaczone dni',
      },
      contactPersons: {
        title: 'Osoby kontaktowe',
        empty: 'Brak osób kontaktowych. Kliknij "Dodaj" aby dodać nową.',
        saveSuccess: 'Osoby kontaktowe zostały zapisane',
        saveError: 'Nie udało się zapisać osób kontaktowych',
      },
      contactPerson: {
        name: 'Imię i nazwisko',
        namePlaceholder: 'Wprowadź imię i nazwisko',
        nameRequired: 'Imię i nazwisko jest wymagane',
        title: 'Tytuł/Stanowisko',
        titlePlaceholder: 'np. Pastor',
        email: 'Email',
        emailPlaceholder: 'Twój adres email',
        phone: 'Telefon',
        phonePlaceholder: '+48 123 456 789',
      },
    },
    branches: {
      title: 'Placówki',
      empty: 'Brak placówek',
      name: 'Nazwa placówki',
      namePlaceholder: 'np. Placówka Praga',
      add: 'Dodaj',
      added: 'Placówka dodana',
      removed: 'Placówka usunięta',
      removeConfirm: 'Czy na pewno chcesz usunąć tę placówkę?',
    },
    people: {
      title: 'Ludzie i służby',
      empty: 'Brak przypisań',
      added: 'Osoba dodana',
      updated: 'Zapisano zmiany',
      editTitle: 'Edytuj osobę',
      removed: 'Usunięto przypisanie',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      email: 'E-mail',
      phone: 'Telefon',
      customService: 'Inna służba',
      customServiceName: 'Nazwa służby',
      service: 'Służba',
      servicePlaceholder: 'Wybierz służbę',
      description: 'Opis',
      createAccount: 'Utwórz konto użytkownika',
      pastorInactive: 'pastor: konto nieaktywne',
      add: 'Dodaj osobę',
      addFormTitle: 'Dodaj nową osobę',
      profileVisibilityTitle: 'Widoczność w profilu zboru',
      showOnList: 'Pokaż na liście zborów',
      showOnListHint: 'Zaznaczone osoby pojawiają się na skróconej karcie w wyszukiwarce zborów. Kolejność odpowiada kolejności na liście.',
      moveUp: 'Przesuń wyżej',
      moveDown: 'Przesuń niżej',
      removeConfirm: 'Czy na pewno chcesz usunąć tę osobę ze zboru?',
      visibility: {
        hidden: 'Ukryty',
        public: 'Publicznie',
        authenticated: 'Zalogowani',
        pastors: 'Pastorzy i biskupi',
      },
      accountRole: 'Uprawnienia',
      accountRolePlaceholder: 'Wybierz uprawnienia',
      roles: {
        none: 'Brak (podstawowe)',
        member: 'Członek',
        owner: 'Właściciel',
        pastor: 'Pastor',
        diacon: 'Diakon',
        bishop: 'Biskup',
        regional_bishop: 'Biskup regionalny',
        branch_responsible: 'Odpowiedzialny za placówkę',
      },
      noServiceTypes: 'Brak typów służb w bazie. Uruchom: python -m cli db churches-backfill',
      accountStatus: {
        none: 'Brak konta',
        invited: 'Zaproszono',
        expired: 'Zaproszenie wygasło',
        active: 'Aktywne',
      },
      sendInvite: 'Wyślij zaproszenie',
      resendInvite: 'Ponów zaproszenie',
      inviteSent: 'Zaproszenie wysłane',
    },
    changeHistory: {
      title: 'Historia zmian',
      empty: 'Brak zarejestrowanych zmian',
      loadError: 'Nie udało się pobrać historii zmian',
      source: {
        admin_manual: 'Edycja ręczna',
        import_paste: 'Import z tekstu',
        email_auto: 'E-mail (automatycznie)',
        email_reviewed: 'E-mail (zatwierdzone ręcznie)',
      },
    },
    completeness: {
      title: 'Kompletność profilu',
      missingPrefix: 'Brakuje:',
      filterLabel: 'Kompletność',
      filterAll: 'Wszystkie',
      filterLow: 'Niska (poniżej 40%)',
      filterMedium: 'Średnia (40–74%)',
      filterHigh: 'Wysoka (od 75%)',
      fields: {
        description: 'Opis',
        street: 'Ulica',
        postal_code: 'Kod pocztowy',
        province: 'Województwo',
        website: 'Strona WWW',
        geolocation: 'Lokalizacja na mapie',
        service_times: 'Godziny nabożeństw',
        card_contacts: 'Osoby kontaktowe',
        contact_email: 'Kontakt z adresem e-mail',
        contact_phone: 'Kontakt z telefonem',
      },
    },
  },
}
